<template functional>
  <div
    v-if="props.isShown"
    class="registration-wizard-steps-wrapper-box"
    :class="{'reg-steps--disabled': props.isDisabledClass}"
  >
    <!-- Inactive icon -->
    <img
      v-if="props.whatStep === 'unfinished'"
      src="@/assets/images/reg_checkmark_inactive.png"
      alt="inactive"
    >
    <!-- Current icon -->
    <img
      v-if="props.whatStep === 'current'"
      src="@/assets/images/reg_checkmark_current.png"
      alt="current"
    >
    <!-- Active icon -->
    <img
      v-if="props.whatStep === 'finished'"
      src="@/assets/images/reg_checkmark_active.png"
      alt="active"
    >

    <span>
      {{ props.text }}
    </span>
  </div>
</template>

<script>
  export default {
    name: "RegistrationStepsBox"
  }
</script>
